api = require '../api'

module.exports =

  getResources: (classroomId) ->
    api.sendAndReceiveRaw
      method: 'GET'
      path: "/api/v2/mail?classroomId=#{classroomId}&tenant=" + TENANT
